import { render, staticRenderFns } from "./rotaListaOsAssoc.vue?vue&type=template&id=12afeb28&scoped=true"
import script from "./rotaListaOsAssoc.vue?vue&type=script&lang=js"
export * from "./rotaListaOsAssoc.vue?vue&type=script&lang=js"
import style0 from "./rotaListaOsAssoc.vue?vue&type=style&index=0&id=12afeb28&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12afeb28",
  null
  
)

export default component.exports